module.exports = __webpack_public_path__ + "img/lihua.55c6e590.png";